import React, { DragEvent } from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export interface DropZoneProps {
    className?: string;
    text: string;
    onDragOver?: (e: DragEvent<HTMLDivElement>) => void;
    onDragEnter?: (e: DragEvent<HTMLDivElement>) => void;
    onDragLeave?: (e: DragEvent<HTMLDivElement>) => void;
    onDrop?: (e: DragEvent<HTMLDivElement>) => void;
}

const DropZone: React.FC<DropZoneProps> = ({
    className,
    text,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop,
}) => {
    return (
        <div
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={className}
        >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', color: 'inherit' }}>
                <SaveAltIcon color="inherit" />
                <span style={{ fontWeight: 'bold', color: 'inherit', marginLeft: '8px' }}>
                    {text}
                </span>
            </div>
        </div>
    );
};

export default DropZone;
